import { StepperRoot } from "./StepperRoot";
import { StepperStep } from "./StepperStep";

const Stepper = Object.assign(StepperRoot, {
  Step: StepperStep,
});

export { Stepper };